import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOther = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M2.53505 6.40234C1.59041 6.4087 1 7.04464 1 7.99088C1 8.99165 1.57717 9.59106 2.54247 9.59742C3.50141 9.59106 4.06058 9.01231 4.07805 7.99141C4.06164 7.01817 3.47335 6.40923 2.53505 6.40287V6.40234Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.99599 6.40234C7.05134 6.4087 6.46094 7.04464 6.46094 7.99088C6.46094 8.99165 7.03811 9.59106 8.0034 9.59742C8.96235 9.59106 9.52151 9.01231 9.53899 7.99141C9.52257 7.01817 8.93429 6.40923 7.99599 6.40287V6.40234Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.4569 6.40234C12.5123 6.4087 11.9219 7.04464 11.9219 7.99088C11.9219 8.99165 12.499 9.59106 13.4643 9.59742C14.4233 9.59106 14.9825 9.01231 14.9999 7.99141C14.9835 7.01817 14.3952 6.40923 13.4569 6.40287V6.40234Z",
			fill: "currentColor"
		})
	]
});
export default SvgOther;
